import {PropsWithChildren} from "react";
import {css, cva, cx} from "@panda/css";

import {CarOutlineIcon, PoiBusIcon, WalkIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {TravelMode} from "../../property/utils/TravelMode";

type IProps = PropsWithChildren<{
    selected: boolean;
    onClick: () => void;
    travelMode: TravelMode | null;
    duration: string | null;
    className?: string;
}>;

const travelModeIcons: Record<TravelMode, typeof CarOutlineIcon> = {
    [TravelMode.DRIVING]: CarOutlineIcon,
    [TravelMode.WALKING]: WalkIcon,
    [TravelMode.TRANSIT]: PoiBusIcon
};

export const TravelModeButton = (props: IProps) => {
    const {selected, travelMode, onClick, duration, className} = props;
    const Icon = travelMode ? travelModeIcons[travelMode] : null;

    return (
        <span className={cx(travelModeButtonStyle({active: selected}), className)} onClick={onClick}>
            {Icon && <Icon size="1.6" wrapperSize="1.6" wrapperColor="transparent" className={iconStyle} />}
            {selected && duration && (
                <Text as="span" variant="info_txt_2" strong>
                    {duration}
                </Text>
            )}
        </span>
    );
};

const travelModeButtonStyle = cva({
    base: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        px: 1,
        borderRadius: 1,
        minWidth: "6.4rem",
        height: "2.4rem"
    },
    variants: {
        active: {
            true: {
                justifyContent: "space-between",
                backgroundColor: "var(--colors-white)",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "var(--colors-gray-800)",
                boxShadow: "0px 4px 4px 0px #00000040"
            },
            false: {
                justifyContent: "center",
                backgroundColor: "var(--colors-background-100)"
            }
        }
    },
    defaultVariants: {
        active: false
    }
});

const iconStyle = css({
    pr: 1
});
import {PropsWithChildren} from "react";
import {css, cva, cx} from "@panda/css";

import {CarOutlineIcon, PoiBusIcon, WalkIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {TravelMode} from "../../property/utils/TravelMode";

type IProps = PropsWithChildren<{
    selected: boolean;
    onClick: () => void;
    travelMode: TravelMode | null;
    duration: string | null;
    className?: string;
}>;

const travelModeIcons: Record<TravelMode, typeof CarOutlineIcon> = {
    [TravelMode.DRIVING]: CarOutlineIcon,
    [TravelMode.WALKING]: WalkIcon,
    [TravelMode.TRANSIT]: PoiBusIcon
};

export const TravelModeButton = (props: IProps) => {
    const {selected, travelMode, onClick, duration, className} = props;
    const Icon = travelMode ? travelModeIcons[travelMode] : null;

    return (
        <span className={cx(travelModeButtonStyle({active: selected}), className)} onClick={onClick}>
            {Icon && <Icon size="1.6" wrapperSize="1.6" wrapperColor="transparent" className={iconStyle} />}
            {selected && duration && (
                <Text as="span" variant="info_txt_2" strong>
                    {duration}
                </Text>
            )}
        </span>
    );
};

const travelModeButtonStyle = cva({
    base: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        px: 1,
        borderRadius: 1,
        minWidth: "6.4rem",
        height: "2.4rem"
    },
    variants: {
        active: {
            true: {
                justifyContent: "space-between",
                backgroundColor: "var(--colors-white)",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "var(--colors-gray-800)",
                boxShadow: "0px 4px 4px 0px #00000040"
            },
            false: {
                justifyContent: "center",
                backgroundColor: "var(--colors-background-100)"
            }
        }
    },
    defaultVariants: {
        active: false
    }
});

const iconStyle = css({
    pr: 1
});
